/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        '[sw:settle] App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered (registration) {
      console.log('[sw:settle] Service worker has been registered.')

      // Routinely check for app updates by testing for a new service worker.
      setInterval(() => {
        registration.update()
      }, 1000 * 60 * 60) // hourly checks
    },
    cached () {
      console.log('[sw:settle] Content has been cached for offline use.')
    },
    updatefound () {
      console.log('[sw:settle] New content is downloading.')
    },
    updated (registration) {
      console.log('[sw:settle] New content is available; please refresh.')

      const event = new CustomEvent('swUpdated', { detail: registration })

      document.dispatchEvent(event)
    },
    offline () {
      console.log('[sw:settle] No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('[sw:settle] Error during service worker registration:', error)
    }
  })

  let refreshing

  navigator.serviceWorker.addEventListener('controllerchange', function () {
    if (refreshing) return

    window.location.reload()

    refreshing = true
  })
}
